import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import {
  type CreateAccountingTypeMutationError,
  getListAccountingTypesQueryKey,
  useCreateAccountingType,
} from '@/entities/masters/api/generated/api';
import { toast } from '@/shared/ui';

export const useAccountingTypesCreateMutation = ({ onSuccess }: { onSuccess: () => void }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useCreateAccountingType({
    request: { suppressToast: true },
    mutation: {
      onSuccess: () => {
        toast.success(
          t('common.messages.create-success', {
            name: t('master-management.labels.accounting-types'),
          }),
        );
        queryClient.invalidateQueries({
          queryKey: getListAccountingTypesQueryKey(),
        });
        onSuccess();
      },
      onError: (error: CreateAccountingTypeMutationError) => {
        if (error.response?.data.error_code === 'VALIDATION_ERROR') {
          toast.error(t('master-management.errors.duplicate-code-yearly'));
          return;
        }
        toast.error(
          t('common.messages.create-failed', {
            name: t('master-management.labels.accounting-types'),
          }),
        );
      },
    },
  });
};
